"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _underscore = require("underscore");

var _DefaultContactProper;

var ContactPropertyOptionKeys = {
  CID: 'cid',
  VALUE: 'value',
  LABEL: 'label',
  DISPLAY_ORDER: 'displayOrder',
  HIDDEN: 'hidden'
};
var DefaultContactPropertyOption = (_DefaultContactProper = {}, (0, _defineProperty2.default)(_DefaultContactProper, ContactPropertyOptionKeys.CID, null), (0, _defineProperty2.default)(_DefaultContactProper, ContactPropertyOptionKeys.VALUE, ''), (0, _defineProperty2.default)(_DefaultContactProper, ContactPropertyOptionKeys.LABEL, ''), (0, _defineProperty2.default)(_DefaultContactProper, ContactPropertyOptionKeys.DISPLAY_ORDER, -1), (0, _defineProperty2.default)(_DefaultContactProper, ContactPropertyOptionKeys.HIDDEN, false), _DefaultContactProper);

var ContactPropertyOption = function ContactPropertyOption(data) {
  (0, _classCallCheck2.default)(this, ContactPropertyOption);
  var formField = (0, _underscore.pick)(data, Object.values(ContactPropertyOptionKeys || {}));
  return Object.assign({}, DefaultContactPropertyOption, formField);
};

exports.default = ContactPropertyOption;
module.exports = exports.default;